<div class="title">
	<a class="logo" routerLink="./"></a>
	<span class="title">{{currentTitle}}</span>
</div>

@if (showButtons) {
	<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Button for main menu">
		<mat-icon>menu</mat-icon>
	</button>
	<mat-menu #menu="matMenu">

		<a mat-menu-item routerLink="/appointments">
			<mat-icon>list</mat-icon>
			<span>Appointments</span>
		</a>

		<a mat-menu-item routerLink="/organizations">
			<mat-icon>list</mat-icon>
			<span>Organizations</span>
		</a>

		<a mat-menu-item routerLink="/users">
			<mat-icon>list</mat-icon>
			<span>Users</span>
		</a>

		<a mat-menu-item routerLink="/patients">
			<mat-icon>list</mat-icon>
			<span>Patients</span>
		</a>

		<a mat-menu-item routerLink="/tools">
			<mat-icon>build</mat-icon>
			<span>Tools</span>
		</a>

		<mat-divider></mat-divider>

		<button mat-menu-item (click)="logout()">
			<mat-icon>logout</mat-icon>
			<span>Logout</span>
		</button>
	</mat-menu>
}

